import React, { useState, useEffect } from "react";
import apiClient from "../api/api";
import { toast } from "react-toastify";
import "../styles/leaveApplication.css";

const LeaveRequestAdmin = () => {
    const [form, setForm] = useState({
        user_id: "",
        start_date: "",
        end_date: "",
        type: "annual",
        reason: "",
    });
    const [users, setUsers] = useState([]);

    // Fetch all users from API
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await apiClient.get("/employees");
                setUsers(res.data);
            } catch (err) {
                console.error("Error fetching users:", err);
                toast.error("Failed to load users list");
            }
        };
        fetchUsers();
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const submitLeave = async () => {
        try {
            if (!form.user_id || !form.start_date || !form.end_date) {
                toast.error("Please fill all required fields");
                return;
            }

            await apiClient.post("/leave/request", form);
            toast.success("Leave request submitted");

            // Reset form
            setForm({
                user_id: "",
                start_date: "",
                end_date: "",
                type: "annual",
                reason: "",
            });
        } catch (err) {
            console.error("Error submitting leave request:", err);
            toast.error("Failed to submit leave request");
        }
    };

    return (
        <div className="leave-request-container">
            <h2 className="leave-request-title">Request Leave</h2>

            <div className="leave-form">
                {/* User dropdown */}
                <label htmlFor="user_id">User</label>
                <select
                    name="user_id"
                    value={form.user_id}
                    onChange={handleChange}
                    className="leave-form-input"
                >
                    <option value="">Select Employee</option>
                    {users.map((u) => (
                        <option key={u.user_id} value={u.user_id}>
                            {u.user.name}
                        </option>
                    ))}
                </select>

                {/* Start Date */}
                <label htmlFor="start_date">Start Date</label>
                <input
                    type="date"
                    name="start_date"
                    value={form.start_date}
                    onChange={handleChange}
                    className="leave-input"
                />

                {/* End Date */}
                <label htmlFor="end_date">End Date</label>
                <input
                    type="date"
                    name="end_date"
                    value={form.end_date}
                    onChange={handleChange}
                    className="leave-input"
                />

                {/* Leave Type */}
                <label htmlFor="type">Leave Type</label>
                <select
                    name="type"
                    value={form.type}
                    onChange={handleChange}
                    className="leave-input"
                >
                    <option value="sick">Sick</option>
                    <option value="annual">Annual</option>
                    <option value="authorised">Authorised</option>
                    <option value="maternity">Maternity</option>
                    <option value="paternity">Paternity</option>
                    <option value="bereavement">Bereavement</option>
                </select>

                {/* Reason */}
                <label htmlFor="reason">Reason</label>
                <textarea
                    name="reason"
                    value={form.reason}
                    onChange={handleChange}
                    placeholder="Reason for leave"
                    className="leave-textarea"
                />

                {/* Submit */}
                <button onClick={submitLeave} className="leave-submit-btn">
                    Submit
                </button>
            </div>
        </div>
    );
};


export default LeaveRequestAdmin;
